/**
 * Created by zzy on 2019/8/5.
 */
import PowerMonitoring from './PowerMonitoring.vue'
export default PowerMonitoring



// WEBPACK FOOTER //
// ./src/views/monitoring/powerMonitoring/index.js